import { monoFont } from '@medcom/shared-ui/styles/globalCss.ts';
import { matchesTokens, tokenize } from '@medcom/shared-ui/utils/tokenSearch.ts';
import { Button, Form, type FormInstance, Input, Transfer, Typography } from 'antd';
import type React from 'react';
import { useMemo } from 'react';
import { type FragmentType, getFragmentData } from '../../../../graphql/generated';
import type { CatalogCreateInput, CatalogForm_ParameterFragment, CatalogUpdateInput } from '../../../../graphql/generated/graphql.ts';
import { ParameterFragment } from './CatalogForm.gql';

export const CatalogForm: React.FC<{
  form: FormInstance<CatalogCreateInput | CatalogUpdateInput>;
  parameterFragments: FragmentType<typeof ParameterFragment>[];
  onFinish: (values: CatalogCreateInput | CatalogUpdateInput) => void;
  initialValues?: CatalogCreateInput;
}> = ({ form, parameterFragments, onFinish, initialValues }) => {
  const parameters = getFragmentData(ParameterFragment, parameterFragments);

  const sortedParameters = useMemo(() => {
    return [...parameters].sort((a, b) => a.shortName.localeCompare(b.shortName));
  }, [parameters]);

  return (
    <Form layout="vertical" form={form} onFinish={onFinish} initialValues={initialValues}>
      <Form.Item name="name" label="Name" rules={[{ required: true, whitespace: true }]}>
        <Input autoFocus />
      </Form.Item>
      <Form.Item name="description" label="Beschreibung">
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item name="parameterIds" label="Parameter" valuePropName="targetKeys">
        <Transfer<CatalogForm_ParameterFragment>
          dataSource={sortedParameters}
          titles={['Verfügbare Parameter', 'Ausgewählte Parameter']}
          render={param => (
            <>
              <span className={monoFont}>{param.shortName}</span> <Typography.Text type="secondary">{param.longName}</Typography.Text>
            </>
          )}
          showSearch
          filterOption={(inputValue, param) =>
            matchesTokens(param, tokenize(inputValue), [p => p.shortName, p => p.longName, p => p.synonyms])
          }
          styles={{ section: { height: '400px', width: '100%', overflow: 'hidden' } }}
          rowKey={param => param.id}
        />
      </Form.Item>
      {/* hack for enter button support */}
      <Button htmlType="submit" hidden />
    </Form>
  );
};
